export const JobDetailsTypes = {
  GET_JOB_DETAILS: 'GET_JOB_DETAILS',
  CLEAR_JOB_DETAILS: 'CLEAR_JOB_DETAILS',
};
